<div class="header-language">
  <select (ngModelChange)="changeLanguage($event)" [(ngModel)]="selectedLanguage"
    class="header-lang__select-overlay" id="header-lang-select">
    @for (language of languages; track language) {
      <option
        [language]="language"
        [ngValue]="language"
        [short]="false"
        render-language>
        {{language}}
      </option>
    }
  </select>

  <label for="header-lang-select">
    <span [language]="selectedLanguage" [short]="false" class="header-lang__full" render-language></span>
    <span [language]="selectedLanguage" [short]="true" class="header-lang__iso" render-language></span>
    <svg class="icon-arrow-down" height="7" viewBox="0 0 12 7" width="12">
      <use xlink:href="/images/icons/svg-sprite.svg#arrow-down"></use>
    </svg>
  </label>
</div>
